import React from 'react'
import { Card, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { PhoneOutlined, MailOutlined } from '@ant-design/icons'
import { ContactsProposalFragment } from './Contacts.generated-types'

const { Text, Title } = Typography

interface ContactsProps {
  proposal: ContactsProposalFragment
}

export const Contacts: React.FC<ContactsProps> = ({ proposal: { space } }) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Title level={4}>{space.venue?.name || ''}</Title>
      <Text>
        <MailOutlined />
        {` ${space.hostContact?.email}` || t('proposal.contact.email', 'No email provided')}
      </Text>
      <div style={{ height: 8 }} />
      <Text>
        <PhoneOutlined />
        {` ${space.hostContact?.phoneNumber}` ||
          t('proposal.contact.phone', 'No phone number provided')}
      </Text>
    </Card>
  )
}
